import React, { useEffect } from 'react';
import {
    Box,
    Typography,
    FormControl,
    Select,
    MenuItem,
    SelectChangeEvent,
    FormHelperText,
} from '@mui/material';
import { SkillArr } from '../../../../Constants/Arrays';
import { SingleSkillDropdownProps } from '../../types/profileForm.types';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const SingleSkillDropdown: React.FC<SingleSkillDropdownProps> = ({
    id,
    label,
    value,
    error,
    required = false,
    onChange,
    onBlur,
    excludeSkills = [],
}) => {
   
    
    const handleChange = (event: SelectChangeEvent<string>) => {
        console.log("SingleSkillDropdown handleChange event:", event);
        const selectedValue = event.target.value;
        console.log("SingleSkillDropdown selectedValue:", selectedValue);
        onChange('skillName', selectedValue);
    };

    const handleBlur = () => {
        onBlur('skillName');
    };

    console.log("skillArray length:", SkillArr, "Rendering SingleSkillDropdown with value:", value, "and excludeSkills:", excludeSkills, "label :", label);

    // Filter out excluded skills
    const availableSkills = SkillArr.filter(skill => 
        !excludeSkills.includes(skill.label)
    );

    return (
        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
            <Typography
                variant="subtitle1"
                sx={{
                    minWidth: { xs: '120px', sm: '200px' },
                    flexShrink: 0,
                    fontSize: '14px',
                    fontWeight: 600,
                    color: '#212529',
                }}
            >
                {label}
                {required && (
                    <Typography component="span" sx={{ color: '#dc3545', ml: 0.5 }}>
                        *
                    </Typography>
                )}
            </Typography>

            <Box sx={{ flex: 1 }}>
                <FormControl fullWidth error={!!error}>
                    <Select
                         value={
    SkillArr.find(skill => skill.label.toLowerCase() === value?.toLowerCase())?.label || ''
  }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        displayEmpty
                        MenuProps={MenuProps}
                        sx={{
                            height: '48px',
                            borderRadius: '8px',
                            backgroundColor: '#fff',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: error ? '#dc3545' : '#dee2e6',
                                borderWidth: '1px',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: error ? '#dc3545' : '#007bff',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: error ? '#dc3545' : '#007bff',
                                borderWidth: '2px',
                            },
                            '& .MuiSelect-select': {
                                padding: '12px 16px',
                                fontSize: '16px',
                            },
                        }}
                    >
                        <MenuItem value="" disabled>
                            <Typography sx={{ color: '#6c757d', fontSize: '16px' }}>
                                Select a skill...
                            </Typography>
                        </MenuItem>
                        {availableSkills.map((skill) => (
                            <MenuItem
                                key={skill.id}
                                value={skill.label}
                                sx={{
                                    fontSize: '16px',
                                    '&:hover': {
                                        backgroundColor: '#f8f9fa',
                                    },
                                    '&.Mui-selected': {
                                        backgroundColor: '#e7f1ff',
                                        '&:hover': {
                                            backgroundColor: '#d1ecf1',
                                        },
                                    },
                                }}
                            >
                                {skill.label}
                            </MenuItem>
                        ))}
                    </Select>
                    {error && (
                        <FormHelperText sx={{ fontSize: '12px', color: '#dc3545', ml: 0, mt: '4px' }}>
                            {error}
                        </FormHelperText>
                    )}
                </FormControl>
            </Box>
        </Box>
    );
};

export default SingleSkillDropdown;